import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PopupInfo } from './shared/components/popup-info/popup-info';
import { PopupConfirm } from './shared/components/popup-confirm/popup-confirm';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PopupInfo, PopupConfirm],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly themeService = inject(ThemeService);
  protected readonly title = signal('partner-mass-market');
}
